import {Component, inject} from '@angular/core';
import {SessionService} from '../../@core/session.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {NzDescriptionsComponent, NzDescriptionsItemComponent} from 'ng-zorro-antd/descriptions';
import {NzCardComponent} from 'ng-zorro-antd/card';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {RouterLink} from '@angular/router';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {NzAlertComponent} from 'ng-zorro-antd/alert';

@Component({
  selector: 'app-menu-page',
  templateUrl: './menu-page.component.html',
  styleUrls: ['./menu-page.component.scss'],
  imports: [NzDescriptionsComponent, NzDescriptionsItemComponent, NzCardComponent, NzRowDirective, NzColDirective, RouterLink, NzIconDirective, NzAlertComponent]
})
export class MenuPageComponent {

  private sess = inject(SessionService);
  user = toSignal(this.sess.getUser$());

}
